/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import { getTriAppConfig } from "../../TriAppConfig";

const DICTIONARY_API_URL = "/p/dictionary/getTranslatedMessages";
const LANGUAGE_ID_PARAM_NAME = "languageId";
const TAG_PARAM_NAME = "tag";
const REFRESH_USERFILES_CACHE_PARAM_NAME = "refreshUserfilesCache";

export async function requestTranslatedDictionary(
  messages,
  tag,
  languageId,
  refreshUserfilesCache = false
) {
  const { tririgaUrl } = getTriAppConfig();

  const dictionaryUrl = new URL(`${tririgaUrl}${DICTIONARY_API_URL}`);
  dictionaryUrl.searchParams.set(TAG_PARAM_NAME, tag);
  dictionaryUrl.searchParams.set(LANGUAGE_ID_PARAM_NAME, languageId);
  dictionaryUrl.searchParams.set(
    REFRESH_USERFILES_CACHE_PARAM_NAME,
    refreshUserfilesCache
  );

  let dictionaryResponseData = null;
  try {
    const requestOptions = {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ labels: messages }),
    };
    const dictionaryRequest = new Request(dictionaryUrl, requestOptions);
    const dictionaryResponse = await fetch(dictionaryRequest);
    dictionaryResponseData = await dictionaryResponse.json();
    if (!dictionaryResponse.ok) {
      throwRequestTranslatedDictionaryError(dictionaryResponse.status, null);
    }
    return dictionaryResponseData.dictionary;
  } catch (error) {
    if (dictionaryResponseData.message)
      console.error(dictionaryResponseData.message);
    throwRequestTranslatedDictionaryError(null, error);
  }
}

function throwRequestTranslatedDictionaryError(responseCode, error) {
  if (!responseCode) throw new Error({ errorType: "request-failed" });
  switch (responseCode) {
    case 401:
      throw new Error({ errorType: "unauthorized" });
    default:
      throw new Error({ errorType: "request-failed" });
  }
}
